export default __webpack_public_path__ + "static/media/operational-env-image.f7f0c0d4.png";